<template>
  <div class="controls">
    <div class="wrapper">
      <hgroup class="desc">
        <h1 class="get-up-title" v-t="'preview.getUpTitle'" />
        <h2 class="short-title" v-t="'preview.shortTitle'" />
      </hgroup>
      <base-button @click.native="handleOpenPayment" small v-t="'preview.openPayment'" />
    </div>
  </div>
</template>

<script>
import store from '@/store';

export default {
  methods: {
    async handleOpenPayment() {
      const route =
        typeof window.ReactNativeWebView !== 'undefined' && window.GO_TO_MOBILE_PAYMENT_PAGE
          ? '/mobile-payment'
          : '/payment';

      this.$router.push(route);
      this.rnAppMetricaReportEvent('publish', store.appMetricaData);
    },
  },
};
</script>

<style scoped src="./sitePreviewControls.css"></style>
